import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getOrganization,
  organizationListSuccessful,
  organizationByIdSuccessful,
  isModelVisible,
} from "./organizationSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";


function* OrganizationList({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/organization/", params);
    yield put(organizationListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddOrganization({ payload }) {
  try {
    if (payload.id == 0 || payload.id == null || payload.id == undefined) {
      const response = yield call(postAdd, "/masters/organization/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Organization Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getOrganization({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Organization. Please try again!
              </p>
            </div>
          ),
        });
      }
    } else {
      const response = yield call(
        postEdit,
        "/masters/organization/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Organization Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getOrganization({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit  Organization. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteOrganization({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/organization/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Organization has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getOrganization({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Organization has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

function* OrganizationByID({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      "/masters/organization/" +  payload.id,
      {}
    );
    yield put(organizationByIdSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetOrganization() {
  yield takeEvery("organization/getOrganization", OrganizationList);
}
export function* watchOrganizationAdd() {
  yield takeEvery("organization/organizationAdd", AddOrganization);
}
export function* watchGetOrganizationByID() {
  yield takeEvery("organization/getOrganizationByID", OrganizationByID);
}
export function* watchOrganizationDelete() {
  yield takeEvery("organization/organizationDelete", DeleteOrganization);
}

function* OrganizationSaga() {
  yield all([fork(watchGetOrganization), fork(watchOrganizationAdd), fork(watchGetOrganizationByID), fork(watchOrganizationDelete)]);
}

export default OrganizationSaga;
